import React, { useEffect, useState } from "react";
import "./style.scss";
import mentorProfile1 from "./img/mentor-profile1.png";
import mentorProfile2 from "./img/mentor-profile2.png";
import mentorProfile from "./img/mentor-pic.jpg";
import newBadge from "../../../../assets/images/new-mentor.png";
import goldBadge from "../../../../assets/images/gold-mentor.png";
import silveradge from "../../../../assets/images/silver-mentor.png";
import platinumBadge from "../../../../assets/images/platinum-mentor.png";
import startupIndia from "./img/startup-india.png";
import linkedin from "./img/linkedin.png";
import hashImage from "../../../../assets/images/hashImage.jpeg";
import profileBackground from "./img/profile-back01.jpg";
import profileBackground2 from "./img/profile-back02.jpg";
import globe from "./img/globe.png";
import { useParams, withRouter, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import {
  // Typography,
  Button,
  // Stepper,
  // Step,
  // StepLabel,
} from "@material-ui/core";

import { getMentorListData } from "../../dependencies/action";
import { GET_SIGNAL_MENTOR_DATA } from "../../../common/constants/ApplicationUrl";
import api from "../../../common/dependencies/utils/Api";
import { isLoading } from "../../../common/constants/actionConstants";
import { useDispatch } from "react-redux";
function SingleMentor1(props) {
  const dispatch = useDispatch();
  const queryString = window.location;
  const mentorEmail = queryString.pathname.replace("/mentor-profile/", "");
  const history = useHistory();
  const [mentorDetails, setMentorDetails] = useState();
  const [loader, setLoader] = useState(false);
  const { getSingleMentorData, getMentorListData, getSingleMentor1 } = props;
  const LoginRole = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  // const testData = props.history.location.state.data;
  // useEffect(() => {
  //   // if(getSingleMentor1){
  //   //   setMentorDetails(getSingleMentorData);
  //   // }
  //   // else
  //   if (getSingleMentorData) {
  //     console.log("came here")
  //     setLoader(true)
  //     setMentorDetails(getSingleMentorData);
  //   }
  //   else{
  //     setLoader(true)
  //     console.log("came here2")
  //   }
  // }, [getSingleMentorData]);
  const getMentorData = () => {

    api
      .POST(GET_SIGNAL_MENTOR_DATA, {
        email_id: mentorEmail 
      })
      .then((res) => {
        setLoader(true)
        dispatch(isLoading(false))
        if(res == undefined){
          setMentorDetails(res)
        }
        else{
          setMentorDetails(res?.data?.data)
        }
      })
      .catch((err) => {});
  };
  useEffect(()=>{
    dispatch(isLoading(true))
    getMentorData()
  },[])
  // useEffect(() => {
  //   if (window.id !== undefined || window.id !== null || window.id !== "") {
  //     if (mentorEmail) {
  //       getMentorListData({ email_id: mentorEmail });
  //     } else {
  //       getMentorListData({ email_id: window.id });
  //     }
  //   } else getMentorListData({ email_id: mentorEmail });
  // }, []);
  const openlinkdinURL = (linkdinUrl) => {
    window.open(
      linkdinUrl.includes("http") ? linkdinUrl : "https://" + linkdinUrl,
      "_blank"
    );
  };
  function getQuarter() {
    
  var today = new Date();
  var year = new Date().getFullYear();
  var quarter = Math.floor((today.getMonth() + 3) / 3);
  if (quarter == 1) {
    return `Oct ${year - 1} To Dec ${year - 1}`;
  } else if (quarter == 2) {
    return `Jan ${year} To Mar ${year}`;
  } else if (quarter == 3) {
    return `Apr ${year} To Jun ${year}`;
  } else {
    return `Jul ${year} To Sept ${year}`;
  }
  }
  const clickedOnBack = () => {
    if (history.location.state.prevPage === "mentorPage") {
      localStorage.setItem("allMentorList", "allMentorList");
      // document.body.style.overflow = "hidden"
      history.push("/dashboard", {
        state: {
          fromModule: "mentorDashboardHome",
        },
      });
    }
    // localStorage.setItem("allMentorList", "allMentorList");
    else history.goBack();
  };

  const renderProfileCard = () => {
    return (
      <div className="m-0 p-0 container h-100">
        <div class="row">
          {mentorDetails?.organization_name !== null ||
          mentorDetails?.current_designation !== null ||
          mentorDetails?.country !== null ||
          mentorDetails?.state !== null ||
          mentorDetails?.city !== null ? (
            <div
              class="col-md-6 col-sm-12 col-lg-6 wow"
              style={{ paddingRight: "0" }}
            >
              <div
                class="profile-data pb-5"
                style={{
                  backgroundImage: { profileBackground },
                  backgroundPosition: "bottom right",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <div className="mh-50">
                  {mentorDetails && mentorDetails?.organization_name && (
                    <div class="sub-data">
                      <h3>Company :</h3>
                      <h4 className="pt-2">
                        {mentorDetails?.organization_name}
                      </h4>
                    </div>
                  )}
                  {mentorDetails && mentorDetails?.current_designation && (
                    <div class="sub-data">
                      <h3>Designation :</h3>
                      <h4 className="pt-2">
                        {mentorDetails?.current_designation}
                      </h4>
                    </div>
                  )}
                  {mentorDetails && mentorDetails?.country && (
                    <div class="sub-data">
                      <h3>Country :</h3>
                      <h4 className="pt-2">{mentorDetails?.country}</h4>
                    </div>
                  )}
                  {mentorDetails && mentorDetails?.state && (
                    <div class="sub-data">
                      <h3>State :</h3>
                      <h4 className="pt-2">{mentorDetails?.state}</h4>
                    </div>
                  )}
                  {mentorDetails && mentorDetails?.city && (
                    <div class="sub-data">
                      <h3>City :</h3>
                      <h4 className="pt-2">{mentorDetails?.city}</h4>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          {mentorDetails?.sectors !== null ||
          mentorDetails?.services !== null ||
          mentorDetails?.stage !== null ? (
            <div class="col-md-6 col-sm-12 col-lg-6  fadeInDown">
              <div
                class="profile-data2  pb-5"
                style={{
                  background: { profileBackground2 },
                  backgroundPosition: "bottom right",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                }}
              >
                {mentorDetails?.sectors ? (
                  <div class="sub-data">
                    <h3>Industry / Sector :</h3>
                    <ol className="pt-2">
                      {mentorDetails?.sectors
                        .filter(Boolean)
                        .map((data, index) => {
                          return <li key={index}>{data}</li>;
                        })}
                    </ol>
                  </div>
                ) : (
                  ""
                )}
                {mentorDetails?.subindustry ? (
                  <div class="sub-data">
                    <h3>Industry / Sector Keywords :</h3>
                    <ol className="pt-2">
                      {mentorDetails?.subindustry
                        .filter(Boolean)
                        .map((data, index) => {
                          return (
                            <li key={index} style={{ fontSize: "20px" }}>
                              {data}
                            </li>
                          );
                        })}
                    </ol>
                  </div>
                ) : (
                  ""
                )}
                {mentorDetails?.services ? (
                  <div class="sub-data">
                    <h3>Specialization / Function :</h3>
                    <ol className="pt-2">
                      {mentorDetails?.services
                        .filter(Boolean)
                        .map((data, index) => {
                          return (
                            <li key={index} style={{ fontSize: "20px" }}>
                              {data}
                            </li>
                          );
                        })}
                    </ol>
                  </div>
                ) : (
                  ""
                )}
                {mentorDetails?.subspecialization ? (
                  <div class="sub-data">
                    <h3>Specialization / Function Keywords:</h3>
                    <ol className="pt-2">
                      {mentorDetails?.subspecialization
                        .filter(Boolean)
                        .map((data, index) => {
                          return (
                            <li key={index} style={{ fontSize: "20px" }}>
                              {data}
                            </li>
                          );
                        })}
                    </ol>
                  </div>
                ) : (
                  ""
                )}
                {mentorDetails?.stages && (
                  <div class="sub-data">
                    <h3>Preferred stage of the startup:</h3>
                    <ol className="pt-2">
                      {mentorDetails?.stages
                        .filter(Boolean)
                        .map((data, index) => {
                          return (
                            <li key={index} style={{ fontSize: "20px" }}>
                              {data}
                            </li>
                          );
                        })}
                    </ol>
                    {/* <h4 className="pt-2">{mentorDetails.subspecialization}</h4> */}
                  </div>
                )}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="singleMentor mentorviewproFile">
     
      {loader && mentorDetails !== "" && mentorDetails !== undefined ? (
        mentorDetails?.applicationStatus==="VERIFIED"?
       (<section id="banner">
          <div class="w-100 pt-50 pb-50 position-relative">
            <div class="container">
              {/* <div className="backbtnviewprofile">
                <Button
                  className="top-btn"
                  variant="contained"
                  color="primary"
                  // className="display-Back-btn"
                  style={{
                    backgroundColor: "#3AC2D7",
                    color: "#fff",
                    width: "150px",
                    // marginTop: "20px",
                    marginBottom: "20px",
                    marginRight: "8px",
                    display: "flex",
                    fontSize: "16px",
                    fontWeight: 600,
                    lineHeight: 1.75,
                    letterSpacing: "0.02857em",
                    textTransform: "uppercase",
                    fontFamily: "Montserrat",
                    //  justifyContent: 'flex-start',
                  }}
                  // className="viewApplibackbtn"
                  onClick={() => {
                    clickedOnBack();
                  }}
                >
                  {" "}
                  Back
                </Button>
              </div> */}
              <div class="row">
                <div class="col-md-3 col-sm-12 col-lg-3 wow slideInLeft text-center">
                  {mentorDetails && mentorDetails.name ? (
                    <a className="single-mentor-headline new">
                      {mentorDetails.name}{" "}
                    </a>
                  ) : (
                    <h1>Name is not available </h1>
                  )}
                </div>

                <div
                  class="col-md-6 col-sm-12 col-lg-6 wow slideInRight d-none d-sm-flex"
                  style={{ right: "1rem", position: "relative" }}
                >
                  <img src={mentorProfile1} style={{ width: "50%" }} />
                </div>
                <div class="col-md-3 col-sm-12 col-lg-3 "></div>
              </div>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-md-3 col-sm-12 col-lg-3 wow slideInLeft p-0 px-1">
                  <div>
                    <div
                      class="mckp-img text-center tilt w-100 d-block position-relative "
                      style={{ height: "auto" }}
                    >
                      <img
                        class="img-fluid imageSource d-block "
                        src={
                          mentorDetails?.image
                            ? mentorDetails?.image
                            : hashImage
                        }
                        style={{
                          maxHeight: "280px",
                          height: "275px",
                          objectFit: "contain",
                          // objectPosition: "top",
                          border: "1px solid #3e495438",
                          padding: "0px",
                          borderRadius: "3px",
                          background: "#eeeeee",
                        }}
                        alt=""
                      />
                      {LoginRole && LoginRole.role === "Admin" ? (
                        <>
                          {localStorage.getItem("SavedLoggedInData") &&
                          JSON.parse(localStorage.getItem("SavedLoggedInData"))
                            .role === "Admin" ? (
                            <div className="newuserTooltip top-btn">
                              <a
                                class="complete-btn mentor-btn viewResumePosition "
                                target="_blank"
                                href={mentorDetails?.resumePath}
                              >
                                VIEW RESUME/PROFILE
                              </a>
                              <span className="tooltiptext viewResume tooltip-bottom">
                                View Resume/Profile
                              </span>
                            </div>
                          ) : (
                            ""
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                    <div class="container" style={{ height: "auto" }}>
                      <div class="row pt-0" id="mentor-details">
                        <div class="row d-flex justify-content-between">
                          <div class="col-md-3 col-sm-12 col-lg-3 wow fadeInDown displayNone d-none d-sm-flex align-items-start">
                            <img src={mentorProfile2} />
                          </div>

                          <div class="col-md-4 col-sm-12 col-lg-4 pt-10 wow fadeInDown newuserTooltip">
                            <ul
                              class="mentor-social"
                              style={{ cursor: "pointer" }}
                            >
                              {mentorDetails?.appLindin_url !== null &&
                              mentorDetails?.appLindin_url !== "" ? (
                                <li>
                                  <p
                                    onClick={() =>
                                      openlinkdinURL(
                                        mentorDetails?.appLindin_url
                                      )
                                    }
                                    // href={mentorDetails?.appLindin_url}
                                    // target="_blank"
                                  >
                                    <img src={linkedin} />
                                  </p>
                                  <span className="tooltiptext viewLinkedin tooltip-bottom newlinkedintool">
                                    View LinkedIn Profile
                                  </span>
                                </li>
                              ) : (
                                ""
                              )}
                              {mentorDetails?.website &&
                              mentorDetails?.website !== null &&
                              mentorDetails?.website !== "" ? (
                                <li>
                                  <a
                                    href={mentorDetails?.website}
                                    target="_blank"
                                  >
                                    <img src={globe} />
                                  </a>

                                  <span className="tooltiptext viewLinkedin tooltip-bottom">
                                    View Website
                                  </span>
                                </li>
                              ) : mentorDetails?.personalblogurl &&
                                mentorDetails?.personalblogurl !== null &&
                                mentorDetails?.personalblogurl !== "" ? (
                                <li>
                                  <a
                                    href={mentorDetails?.personalblogurl}
                                    target="_blank"
                                  >
                                    <img src={globe} />
                                  </a>
                                  <span className="tooltiptext viewLinkedin tooltip-bottom">
                                    View Website
                                  </span>
                                </li>
                              ) : (
                                ""
                              )}
                            </ul>

                            {/* from the html start*/}

                            {/* from the html start*/}
                          </div>

                          {mentorDetails?.badge ? (
                            <div class="mentor-box-new specificcomponentData">
                              <div
                                class="top"
                                style={{
                                  position: "absolute",
                                  marginTop: "-35%",
                                  marginLeft: "26%",
                                }}
                              >
                                <div class="top-circle"></div>
                                <div class="top-circle">&nbsp;</div>
                                <div class="top-circle"></div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <img
                                  src={
                                    mentorDetails?.badge === "NEW"
                                      ? newBadge
                                      : mentorDetails?.badge === "SILVER"
                                      ? silveradge
                                      : mentorDetails?.badge === "GOLD"
                                      ? goldBadge
                                      : mentorDetails?.badge === "PLATINUM"
                                      ? platinumBadge
                                      : ""
                                  }
                                />
                              </div>

                              <div class="row">
                                <div
                                  class="col-md-7"
                                  style={{ padding: "10px", paddingTop: "5px" }}
                                >
                                  <img src={startupIndia} />
                                </div>
                                <div
                                  class="col-md-5"
                                  style={{ padding: "0px" }}
                                >
                                  <p class="mentor-date-new">
                                    {getQuarter()}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          <div>
                            <h3
                              class="text-center"
                              style={{
                                padding: "25px 0px 0px",
                                fontSize: "18px",
                              }}
                            >
                              CURRENTLY MENTORING
                            </h3>
                            <p class="mentor-num">
                              <div class="cir">
                                <div class="circle"></div>
                                <div class="line"></div>
                                <div class="circle">
                                  {mentorDetails?.activeMentorships}
                                </div>
                                <div class="line"></div>
                                <div class="circle"></div>
                              </div>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {mentorDetails?.shortDesription !== null &&
                mentorDetails !== undefined ? (
                  <div class="col-md-8 col-sm-12 col-lg-8 wow slideInRight p-md-0">
                    {mentorDetails?.shortDesription !== "" ? (
                      <div class="profile-content">
                        <p>{mentorDetails?.shortDesription}</p>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="m-0 p-0 container h-100">
                      <div className="row">
                        <div class="col-md-8 col-sm-12 col-lg-12 pt-2 wow fadeInDown">
                          {renderProfileCard()}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div class="col-md-8 col-sm-12 col-lg-8 wow slideInRight">
                    <div class="col-md-8 col-sm-12 col-lg-12 wow fadeInDown">
                      {renderProfileCard()}{" "}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
       )
        : 
        <section id="banner">
          
          <h1 style={{padding:"50px",margin: "auto"}}> This user is {mentorDetails?.applicationStatus==="REJECTED"?"REJECTED": "not APPROVED "} by Maarg Admin</h1>
        </section>
      ) : loader && mentorDetails == undefined && (
        <section id="banner">
         
        <h1 style={{padding:"50px",margin: "auto"}}>No User Found </h1>
      </section>
        // <div class="">
        //   <h2> No User Found Or ....Loading </h2>
        // </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    getSingleMentorData: state.GetMentorDataReducer.mentorListData.data,
    getSingleMentor1: state.GetMentorDataReducer.mentorListData.data,
  };
};
export default connect(mapStateToProps, { getMentorListData })(
  withRouter(SingleMentor1)
);